import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TodoService } from '../../todo.service';
import { ActivatedRoute, Params } from '@angular/router';
import { LocalUserService } from 'app/main/shared/services/localUser';
import { Sort, MatDialog } from '@angular/material';
import * as moment from 'moment';
import { EguardConfirmatialogComponent } from 'app/core/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'todo-planned',
  templateUrl: './planned.component.html',
  styleUrls: ['./planned.component.scss']
})
export class PlannedComponent implements OnInit {
  step = 0;

  @Input()
  preference: any;
  panelOpenState = false;
  @Input()
  projects: any;

  @Output()
  update: EventEmitter<any> = new EventEmitter();

  tasks: any[] = [];

  selectedTask: any;


  isLoading = false;
  showIcon = false;
  progress = true;

  userId: string;
  prioritydata = null;
  filteredProjects = [];

  sortList: string;

  sortedData = [];
  setPriority: string;
  currentDate: Date;
  dialogRef: any;

  delayedEvent = [];
  todayEvent = [];
  tomorrowEvent = [];
  upComingEvent = [];
  suggestedEvent = [];
  constructor(
    private todoService: TodoService,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private localStore: LocalUserService

  ) {
    this.userId = localStore.getUserId();
  }

  ngOnInit() {
    if (this.projects && this.projects.length) {
      this.projects.forEach((project) => this.tasks.push(...project.tasks.filter(task => task.due_date)));
    }
    this.sortedData = this.tasks.slice();
    let data = this.sortedData
    this.sortedData = data.sort((a, b) => {
      const isAsc = true;
      return compare(+a.created_date, +b.created_date, isAsc);
    })

    this.forTodayTasks();

    if (this.preference.hide_completed_subtask_on) {
      this.projects.hideCompleteTask = true
    }
  }
  setStep(index: number) {
    this.step = index;
  }

  stepsComplete(task) {

    return task.steps.filter(step => step.is_completed).length
  }

  hideConfirmationTask(task) {
    if (this.preference.confirm_delete) {
      this.deleteTaskConfirmation(task);
    }
    if (!this.preference.confirm_delete) {
      this.deleteTask(task);
    }
  }
  updateTask(task) {
    this.progress = true;
    this.todoService
      .updateTask(this.userId, task.list_id, task.id, task)
      .subscribe(data => {
        this.update.emit();
        this.progress = false;
      });

    event.stopPropagation();
  }
  priorityData(event) {
    this.prioritydata = event;
    if (event != null) {
      if (event.value !== 'ALL') {
        this.filteredProjects = this.projects.filter(data => {
          return data.priority === event.value;
        });
      } else {
        this.filteredProjects = this.projects;
      }
    } else {
      this.filteredProjects = this.projects;
    }
  }

  deleteTask(event) {
    this.progress = true;
    this.todoService
      .deleteTask(this.userId, event.list_id, event.id)
      .subscribe(data => {
        this.projects.tasks = this.projects.tasks.filter(task => task.id !== event.id);
        this.priorityData(this.prioritydata);
        this.progress = false;
      });
  }
  getTaskCopy(task, project) {
    this.progress = true;
    this.todoService.copyTask(this.userId, task.list_id, task.id, project.id)
      .subscribe(task => {
        this.update.emit();
        this.progress = false;
      })
  }
  getTaskMove(task, project) {
    this.progress = true;
    this.todoService.moveTask(this.userId, task.list_id, task.id, project.id)
      .subscribe(task => {
        this.update.emit();
        this.progress = false;
      })
  }

  createNewList(task) {
    this.progress = true;
    let model = {
      task_id: task.id,
      list_id: task.list_id
    }
    this.todoService.createNewList(this.userId, model)
      .subscribe(list => {
        this.update.emit();
        this.progress = false;
      })
  }
  getNextPriority(value) {
    if (value == 'LOW') {
      return 'MEDIUM'
    } else if (value == 'MEDIUM') {
      return 'HIGH'
    } else if (value = 'HIGH') {
      return 'LOW'
    }
  }

  changePriority(task) {
    task.priority = this.getNextPriority(task.priority)

    this.updateTask(task)
  }


  // sortTaskList(tasks) {
  //   this.tasks = [];
  //   this.sortList = tasks
  //   if (this.projects && this.projects.length) {
  //     this.projects.forEach((project) => {
  //       project.tasks.forEach(task => {
  //         if (task.starred == this.sortList) {
  //           this.tasks.push(task)
  //         }
  //         if (task.is_completed == this.sortList) {
  //           this.tasks.push(task)
  //         }
  //       })
  //     })
  //   }
  // }



  getProjectName(task) {
    let selected = this.projects.find((project => project.id === task.list_id))
    return selected ? selected.name : '';

  }
  addMyDay(task) {
    task.my_day = new Date();
    this.updateTask(task)
  }

  addDueDate(time: string, task) {
    task.due_date = new Date()
    // let currentDate = new Date()
    if (time !== 'today') {
      //   task.due_date = currentDate
      // } else {
      task.due_date = task.due_date.setDate(task.due_date.getDate() + 1).toDate();
    }
    this.updateTask(task)
  }

  setColor(task) {
    this.currentDate = new Date()
    let dueDate = new Date(task.due_date)
    if (moment(dueDate).startOf('day') < moment(this.currentDate).startOf('day')) {
      return 'red';
    }

  }

  forTodayTasks() {
    // task.due_date.setDate(task.due_date.getDate() + 1).toDate()
    this.currentDate = new Date()
    this.tasks.forEach((tasks) => {
      let dueDate = new Date(tasks.due_date)
      if (moment(dueDate).startOf('day') < moment(this.currentDate).startOf('day') && tasks.due_date != null) {
        this.delayedEvent.push(tasks)
      }
      if (moment(dueDate).startOf('day') >= moment(this.currentDate).startOf('day') && moment(dueDate).startOf('day') <= moment(this.currentDate).add(0, 'days').startOf('day') && tasks.due_date != null) {
        this.todayEvent.push(tasks)
      }
      if (moment(dueDate).startOf('day') > moment(this.currentDate).startOf('day') && moment(dueDate).startOf('day') <= moment(this.currentDate).add(1, 'days').startOf('day') && tasks.due_date != null) {
        this.tomorrowEvent.push(tasks)
      }
      if (moment(dueDate).startOf('day') > moment(this.currentDate).add(1, 'days').endOf('day') && moment(dueDate).startOf('day') < moment(this.currentDate).add(4, 'days').startOf('day') && tasks.due_date != null) {
        this.upComingEvent.push(tasks)
      }
      if (moment(dueDate).startOf('day') > moment(this.currentDate).add(3, 'days').startOf('day') || tasks.due_date == null) {
        this.suggestedEvent.push(tasks)
      }
    })
  }

  deleteTaskConfirmation(task) {
    this.dialogRef = this.dialog.open(EguardConfirmatialogComponent, {
      data: {
        confirmMessage: 'Are you sure want to delete this Task?'
      }
    });
    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.deleteTask(task);
        }
      });
  }

  taskListSort(priority) {
    let tasks = this.tasks
    this.sortedData = []
    this.setPriority = priority
    if (this.projects && this.projects.length) {
      tasks.forEach(task => {
        if (task.priority == this.setPriority) {
          this.sortedData.push(task)
        }
      })
    }
  }

  sortData(sort: string) {
    const data = this.tasks.slice();
    if (!sort) {
      this.sortedData = data;
      return;
    }
    this.sortedData = data.sort((a, b) => {
      const isAsc = true;
      switch (sort) {
        case 'title': return compare(b.title, a.title, isAsc);
        case 'starred': return compare(a.starred, b.starred, isAsc);
        case 'my_day': return compare(+a.my_day, +b.my_day, isAsc);
        case 'HIGH': return compare(b.priority, a.priority, isAsc);
        case 'MEDIUM': return compare(a.priority, b.priority, isAsc);
        case 'LOW': return compare(b.priority, a.priority, isAsc);
        case 'due_date': return compare(+a.due_date, +b.due_date, isAsc);
        case 'is_completed': return compare(a.is_completed, b.is_completed, isAsc);
        case 'creation': return compare(a.creation, b.creation, isAsc);
        default: return 0;
      }
    });
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? -1 : 1);
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/components/planned/planned.component.ts